<template>
  <div class="p-common-list">
    <div class="p-common-list_box">
      <el-tabs v-if="commonList.length" v-model="Id" type="border-card">
        <el-tab-pane  v-for="item in commonList" :label="item.name" :key="item.code" >
          <!--        <general-view :ref="item.code" :item="item" :Id="getId"></general-view>-->
        </el-tab-pane>
        <general-view
          v-if="commonList[Id]"
          :ref="commonList[Id].code"
          :item="commonList[Id]"
          :Id="getId"
        ></general-view>
      </el-tabs>
      <p v-else-if="loaded" class="p-common-list_no-data">
        <span>无公海数据</span>
      </p>
    </div>
<!--    <general-view :ref="commonList[Id].code" :item="commonList[Id]" :Id="getId"></general-view>-->
  </div>
</template>
<script>
import generalView from "./generalView";
import {getMenu} from "../../api/seaConfig";

export default {
  name: 'CommonListView',
  components: {
    generalView
  },
  data() {
    return {
      value: 1,
      Id: '0',
      commonList: [],
      loaded: false
    }
  },
  computed: {
    getId() {
      const item = this.commonList[this.Id]
      return item ? Number(item.key) : 0
    }
  },
  methods: {
    async onGetMenuList() {
      const data = await getMenu()
      this.commonList = data.map(item => {
        return {
          key: item.OpenSeaId,
          name: item.OpenSeaName,
          code: `sea_${item.OpenSeaId}`
        }
      })
      this.loaded = true
    }
  },
  async created() {
    await this.onGetMenuList()
  }
}
</script>
<style lang="scss">
.p-common-list {
  box-sizing: border-box;
  height: 100%;
  border: 1px ;
  flex: 1;
  display: flex;

  .p-common-list_box {
    flex: 1;
    display: flex
  }

  .p-common-list_no-data {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #888888;
    font-size: 12px;
  }

  .el-tabs {
    flex: 1;
    box-shadow: none;
    display: flex;
    flex-direction: column;
  }
  .el-tabs__content {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
  }
  .el-tab-pane {
    flex: 1;
  }
}
</style>
